import { ContentSection, Heading, Text } from '@cinch-labs/design-system'
import { StoryBlokRichText, StoryblokImage } from '@cinch-nx/data-storyblok'
import Image from 'next/legacy/image'

import renderWithResolver from '../../rich-text-renderer/rich-text-renderer'
import { PhoneIcon } from './assets'
import styles from './peace-of-mind.module.css'

export interface PeaceOfMindProps {
  image: StoryblokImage
  title: string
  aboveImageBody: StoryBlokRichText
  belowImageBody: StoryBlokRichText
  phoneNumber: string
}

const PeaceOfMind: React.FC<PeaceOfMindProps> = ({
  image,
  title,
  aboveImageBody,
  belowImageBody,
  phoneNumber,
}) => {
  const aboveImageText = () => (
    <>
      <Heading className={styles.title}>{title}</Heading>
      <ContentSection
        sectionWrapperClass={styles.richAboveTextSectionWrapper}
        classNames={{ body: styles.body }}
      >
        {renderWithResolver(aboveImageBody)}
      </ContentSection>
    </>
  )

  return (
    <section className={styles.featureSectionWrapper}>
      <div className={styles.container} data-testid="peace-of-mind-container">
        <div className={styles.contentWrapper}>
          <div className={styles.mobileAboveImageText}>{aboveImageText()}</div>
          <div className={styles.imageWrapper}>
            <Image
              src={image.filename}
              alt={image.alt ?? undefined}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div>
            <div className={styles.desktopAboveImageText}>
              {aboveImageText()}
            </div>
            <ContentSection
              sectionWrapperClass={styles.richBottomTextSectionWrapper}
              classNames={{ body: styles.body }}
            >
              {renderWithResolver(belowImageBody)}
            </ContentSection>
            <a
              href={'tel:' + phoneNumber}
              className={styles.phoneNumberWrapper}
            >
              <PhoneIcon />
              <Text className={styles.phoneNumber}>{phoneNumber}</Text>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PeaceOfMind
